import React from 'react';
import { isUrl } from '../../utils/shared.utils';

export const SVG_S3_PREFIX = 'https://public-content.honeybook.com/sys/svg';

export interface ISVGProps {
    /** Relative path (prefixed with S3 SVG bucket URL) or absolute URL used as-is. */
    path: string;
    /** Width of the rendered `<img>` element in pixels. */
    width?: number;
    /** Height of the rendered `<img>` element in pixels. */
    height?: number;
    /** CSS class forwarded to the `<img>` element. */
    className?: string;
    /** Alt text for the image. Defaults to the value of `path` when omitted. */
    alt?: string;
}

// TODO is there a way to make sure devs use this comp for svgs stored in our repo
// and not for svgs stored in cloudinary?

const HBSVG = ({ path, width, height, className, alt }: ISVGProps) => {
    let _path = path;
    if (!isUrl(path)) {
        // if relative path, add svg prefix
        _path = SVG_S3_PREFIX + path;
    }

    return (
        <img
            src={_path}
            width={width}
            height={height}
            className={className}
            alt={alt || path}
        />
    );
};

export default HBSVG;
